import React from 'react';
import { ISurveyReports } from 'store/survey/surveyTypes';
import {
  ItemPickerList,
  ItemPickerHeader,
  ItemPickerFooter,
  ItemPickerHeaderTitle,
  ItemPickerListContainer,
  LoadingWrapper,
  ItemPickerBackButton,
  ItemPickerSaveButton,
} from 'components/ItemPicker/styles';
import {
  ItemViewerName,
  ItemViewerWrapper,
} from 'components/ItemPicker/ItemViewer/styles';
import BubbleLoading from 'components/BubbleLoading';
import Icon from 'components/Icon';
import { LoadingIcon } from 'components/LoadingIcon/LoadingIcon';
import i18n from '../../../i18n';

interface IComponentProps {
  onSelectReport: (reportId: number[]) => void;
  reports: ISurveyReports;
  reportIds?: Array<number>;
  selectedReport: number[];
  onChangeView: () => void;
  onSaveReport: () => void;
  saving: boolean;
  showBackButton: boolean;
  currentSelected: number[];
}

class ReportPicker extends React.PureComponent<IComponentProps> {
  onSelectAnItem = (reportId: number) => () => {
    const pos = this.props.selectedReport.indexOf(reportId);
    const res = [...this.props.selectedReport];
    if (pos >= 0) res.splice(pos, 1);
    else res.push(reportId);
    this.props.onSelectReport(res);
  };

  render() {
    const {
      onChangeView,
      onSaveReport,
      reportIds,
      reports,
      saving, // TODO: remove saving state from parent
      selectedReport,
      showBackButton,
      currentSelected,
    } = this.props;
    const loading = false;
    return (
      <ItemPickerListContainer>
        <ItemPickerHeader showBackButton={showBackButton}>
          {showBackButton && (
            <ItemPickerBackButton
              type="arrow-right"
              onClick={onChangeView}
              disabled={Boolean(loading)}
            />
          )}
          <ItemPickerHeaderTitle>
            {i18n.t('reportList', { ns: 'survey' })}
          </ItemPickerHeaderTitle>
        </ItemPickerHeader>
        {loading && (
          <LoadingWrapper>
            <BubbleLoading />
          </LoadingWrapper>
        )}
        <ItemPickerList loading={Boolean(loading)}>
          {reportIds && reportIds?.length > 0 ? (
            reportIds?.map((id: number) => {
              const report = reports.data[id];
              const included = currentSelected.includes(id || -1);
              return (
                <ItemViewerWrapper
                  key={id}
                  onClick={included ? undefined : this.onSelectAnItem(id)}
                  selected={selectedReport.includes(id || -1)}
                  disabled={included}
                >
                  <Icon type="bar-chart-2" />
                  <ItemViewerName>{report?.name}</ItemViewerName>
                </ItemViewerWrapper>
              );
            })
          ) : (
            <p style={{ alignSelf: 'center', textAlign: 'center' }}>
              {i18n.t('thereIsNoItem', { ns: 'survey' }) as string}
            </p>
          )}
        </ItemPickerList>
        <ItemPickerFooter>
          <ItemPickerSaveButton
            onClick={onSaveReport}
            isActive={!!selectedReport}
          >
            {i18n.t('save', { ns: 'survey' })}
            {saving ? (
              // TODO: fix marginRight style
              <LoadingIcon
                customStyle={{
                  position: 'relative',
                  marginInlineStart: '0.5rem',
                }}
                color="white"
              />
            ) : (
              <Icon type="arrow-left" className="left" />
            )}
          </ItemPickerSaveButton>
        </ItemPickerFooter>
      </ItemPickerListContainer>
    );
  }
}

export default ReportPicker;
